var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive bg-white radius"},[_c('ArchivedTasks',{staticClass:"m-4",attrs:{"scope":"ACCOUNT"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }